import { NavigationProgress } from "@mantine/nprogress"
import "./App.css"

import { Center, LoadingOverlay, MantineProvider } from "@mantine/core"
import { Suspense, useEffect, useState } from "react"
import { RouterProvider, createBrowserRouter } from "react-router-dom"
import { LeaseRoute } from "./feature/lease/route/lease.route"
import { PropertyRoute } from "./feature/property/route/property.route"
import { RoleRoute } from "./feature/role/route/role-route"
import { TenantRoute } from "./feature/tenant/route/tenant.route"
import { UserRoute } from "./feature/user/route/user.route"
import Dashboard from "./layout/page/dashboard.page"
import AuthGuard from "./shared/auth/component/auth"
import Login from "./shared/auth/component/login/login-component"
import { AuthContextProvider } from "./shared/auth/context/authContext"
import NotFound from "./shared/component/404-not-found/404-not-found"

import ForgotPasswordPage from "./feature/account/page/forgot-password-page"
import {
  AccountRoute,
  ChangePasswordRoute,
  UpdatePasswordRoute,
} from "./feature/account/route/account.route"
import { ActivityRoute } from "./feature/activity/route/activity.route"
import { BillingRoute } from "./feature/billing/route/billing.route"
import { DashBoardRoute } from "./feature/dashboard/route/dashboard.route"
import { NotificationRoute } from "./feature/notification/route/notification.route"
import { OwnerRoute } from "./feature/owner/route/owner.route"
import PortalParkingActivityPage from "./feature/parking-activity/page/portal-parking-activity.page"
import { ParkingActivityRoute } from "./feature/parking-activity/route/parking-activity.route"
import { ParkingLotRoute } from "./feature/parking-lot/route/parking-lot.route"
import { PaymentRoute } from "./feature/payment/route/payment.route"
import { ReportsRoute } from "./feature/reports/route/reports.route"
import { RequestRoute } from "./feature/request/route/request.route"
import { SaleRoute } from "./feature/sale/route/sale.route"
import { SettingRoute } from "./feature/settings/route/tenant.route"
import { AdvancedInternetStatusIndicator } from "./shared/component/InternetStatusIndicator/AdvancedStatusIndicator"

function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setLoading(false)
  }, [])
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <AuthContextProvider>
          <Suspense fallback={<LoadingOverlay visible={true} />}>
            <AuthGuard>
              <Dashboard />
            </AuthGuard>
          </Suspense>
        </AuthContextProvider>
      ),
      children: [
        UserRoute,
        RoleRoute,
        OwnerRoute,
        PropertyRoute,
        TenantRoute,
        PaymentRoute,
        BillingRoute,
        RequestRoute,
        SaleRoute,
        LeaseRoute,
        DashBoardRoute,
        ActivityRoute,
        ReportsRoute,
        NotificationRoute,
        ChangePasswordRoute,
        UpdatePasswordRoute,
        ParkingLotRoute,
        ParkingActivityRoute,
        // SimpleParkingActivityRoute,
        SettingRoute,
        { path: "*", element: <NotFound /> },
      ],
    },
    {path: "parking-activity/portal/:id", element: <PortalParkingActivityPage />},
    {
      path: "/login",
      element: (
        <AuthContextProvider>
          <Login />
        </AuthContextProvider>
      ),
    },
    {
      path: "/forget-password",
      element: (
        <AuthContextProvider>
          <ForgotPasswordPage />
        </AuthContextProvider>
      ),
    },
    AccountRoute,
    { path: "*", element: <NotFound /> },
  ])

  // const themeClass = useSelector((state: RootState) => state.themeReducer.class)
  const themeClass = "dark"
  return (
    <>
      {loading ? (
        <Center>
          <LoadingOverlay visible={true} />
        </Center>
      ) : (
        <MantineProvider
          withGlobalStyles
          withNormalizeCSS
          theme={{
            colorScheme: themeClass === "dark" ? "dark" : "light",
            colors: {
              dark: [
                "#d5d7e0",
                "#acaebf",
                "#8c8fa3",
                "#666980",
                "#4d4f66",
                "#34354a",
                "#2b2c3d",
                "#1d1e30",
                "#0c0d21",
                "#01010a",
              ],
              //    Optional Dark Mode: #374151 : #1d1e30,
            },
          }}
        >
          <NavigationProgress />
          <AdvancedInternetStatusIndicator />
          <div className={themeClass}>
            <RouterProvider router={router} />
          </div>
        </MantineProvider>
      )}
      {/* <MantineInternetStatus /> */}
    </>
  )
}

export default App
